module.exports = __webpack_public_path__ + "static/media/execute_questionTypeAnalysis.c02954f4.png";